import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from './../../s3Func/s3Download';
import { API } from 'aws-amplify';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import './Practice.css';
import VideoWebcamRecorder from './Recorder';
import Day4Practice from '../../Unit2/Day4Practice/Day4Practice';

/**
 *  Creates and runs the practice section for Unit3 Module5
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const ActivelisteningPractice = (props) => {
  // Generate a random number based on the arraysize passed in.
  function getRandomInt(arraysize) {
    return Math.floor(Math.random() * Math.floor(arraysize));
  }

  // Initialize variables to be used later
  const dispatch = useDispatch();
  const background = props.background;
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [practiceVideo, setPracticeVideo] = useState(false);
  const [practiceVideo1, setPracticeVideo1] = useState(false);
  const [practiceVideo2, setPracticeVideo2] = useState(false);
  const [practice, setPractice] = useState(false);
  let [practiceCount, setPracticeCount] = useState(0);
  const [displayPracticeVideo, setDisplayPracticeVideo] = useState('');
  const [displayPracticeVideo1, setDisplayPracticeVideo1] = useState('');
  const [displayPracticeVideo2, setDisplayPracticeVideo2] = useState('');
  const [question, setQuestion] = useState(false);
  const [matchGame, setMatchGame] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [animalVoice, setAnimalVoice] = useState('');
  const [audioReady, setAudioReady] = useState(false);
  const [animalTalk, setAnimaTalk] = useState(false);
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [selectImage, setSelectImage] = useState(null);
  const [changeAnswer, setChangeAnswer] = useState(false);
  const [option1, setOption1] = useState('');
  const [option2, setOption2] = useState('');
  const [answerkey, setAnswerkey] = useState(null);
  const [keyword, setKeyword] = useState('');
  const [recording, setRecording] = useState(false);
  const [conversation, setConversation] = useState(false);
  const [conversation1, setConversation1] = useState(false);
  const [conversation2, setConversation2] = useState(false);
  const [parcticeIntro, setParcticeIntro] = useState(false);
  const [conversationEnd, setConversationEnd] = useState(false);
  const [practiceReview, setPracticeReview] = useState(false);
  const [practiceRrcording, setPracticeRrcording] = useState(false);
  const [showStart, setShowStart] = useState(true);
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const Exit = generateImageUrl('images/Images/close.png');
  const greenCheck = generateImageUrl('images/Module1Images/GreenCheck-Button.png');
  const Mad_Calm = generateImageUrl('images/Module12Images/Practice_Puzzel_Mad_Calm@2x.png');
  const Nervous_Confident = generateImageUrl('images/Module12Images/Practice_Puzzel_Nervous_Confident@2x.png');
  const Sad_happy = generateImageUrl('images/Module12Images/Practice_Puzzel_Sad_happy@2x.png');
  const matchNoGame = {
      img: generateImageUrl('images/Module15Images/practice/you cannot play your game.png'),
      title: 'you cannot play your game',
      audioPrompt: 'appfiles/active_listening/match_no_game.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_mad_no_game.mp3',
  };
  const matchSwimming = {
      img: generateImageUrl('images/Module15Images/practice/you went swimming.png'),
      title: 'you went swimming',
      audioPrompt: 'appfiles/active_listening/swim.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_happy_swim.mp3',
  };
  const matchReadBook = {
      img: generateImageUrl('images/Module15Images/practice/you read a book.png'),
      title: 'you read a book',
      audioPrompt: 'appfiles/active_listening/match_read_book.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_calm_book.mp3',
  };
  const matchLostToy = {
      img: generateImageUrl('images/Module15Images/practice/you lost your toy.png'),
      title: 'you lost your toy',
      audioPrompt: 'appfiles/active_listening/match_lost_toy.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_lost_toy.mp3',
  };
  const matchNoPlayOutside = {
      img: generateImageUrl('images/Module15Images/practice/you cannot play outside.png'),
      title: 'you cannot play outside',
      audioPrompt: 'appfiles/active_listening/match_cannot_play_outside.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_no_play_outside.mp3',
  };
  const matchWorkedHard = {
      img: generateImageUrl('images/Module15Images/practice/you worked hard.png	'),
      title: 'you worked hard',
      audioPrompt: 'appfiles/active_listening/match_worked_hard.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_confident_worked_hard.mp3',
  };
  const matchBrokePencil = {
      img: generateImageUrl('images/Module15Images/practice/you broke your pencil.png'),
      title: 'you broke your pencil',
      audioPrompt: 'appfiles/active_listening/match_broke_pencil.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_mad_pencil.mp3',
  };
  const matchTest = {
      img: generateImageUrl('images/Module15Images/practice/you have a test.png'),
      title: 'you have a test',
      audioPrompt: 'appfiles/active_listening/match_test.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_nervous_test.mp3',
  };
  const matchNewFriend = {
      img: generateImageUrl('images/Module15Images/practice/you made a new friend.png'),
      title: 'you made a new friend',
      audioPrompt: 'appfiles/active_listening/match_new_friend.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_happy_new_friend.mp3',
  };
  const matchAteLunch = {
      img: generateImageUrl('images/Module15Images/practice/you ate lunch.png'),
      title: 'you ate lunch',
      audioPrompt: 'appfiles/active_listening/match_ate_lunch.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_calm_ate_lunch.mp3',
  };
  const matchWonGame = {
      img: generateImageUrl('images/Module15Images/practice/you won your game.png'),
      title: 'you won your game',
      audioPrompt: 'appfiles/active_listening/match_won_game.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_happy_won_game.mp3',
  };
  const matchTired = {
      img: generateImageUrl('images/Module15Images/practice/you are tired.png'),
      title: 'you are tired',
      audioPrompt: 'appfiles/active_listening/match_tired.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_mad_tired_tired.mp3',
  };
  const matchDidBest = {
      img: generateImageUrl('images/Module15Images/practice/you did your best.png'),
      title: 'you did your best',
      audioPrompt: 'appfiles/active_listening/match_you_did_your_best.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_confident_did_best.mp3',
  };
  const matchListenMusic = {
      img: generateImageUrl('images/Module15Images/practice/you listented to music.png'),
      title: 'you listened to music',
      audioPrompt: 'appfiles/active_listening/match_music.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_calm_music.mp3',
  };
  const matchSick = {
      img: generateImageUrl('images/Module15Images/practice/you are sick.png'),
      title: 'you are sick',
      audioPrompt: 'appfiles/active_listening/match_sick.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_sick.mp3',
  };
  const matchNap = {
      img: generateImageUrl('images/Module15Images/practice/you took a nap.png'),
      title: 'you took a nap',
      audioPrompt: 'appfiles/active_listening/match_nap.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_calm_nap.mp3',
  };
  const matchHungry = {
      img: generateImageUrl('images/Module15Images/practice/you are hungry.png'),
      title: 'you are hungry',
      audioPrompt: 'appfiles/active_listening/match_hungry.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_mad_hungry.mp3',
  };
  const matchHurtKnee = {
      img: generateImageUrl('images/Module15Images/practice/you hurt your knee.png'),
      title: 'you hurt your knee',
      audioPrompt: 'appfiles/active_listening/match_hurt_knee.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_hurt_knee.mp3',
  };
  const matchBelieveInYou = {
      img: generateImageUrl('images/Module15Images/practice/you believe in yourself.png'),
      title: 'you believe in yourself',
      audioPrompt: 'appfiles/active_listening/match_believed_in_yourself.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_confident_believe.mp3',
  };
  const matchPlayOutside = {
      img: generateImageUrl('images/Module15Images/practice/you played outside.png'),
      title: 'you played outside',
      audioPrompt: 'appfiles/active_listening/match_played_outside.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_happy_outside.mp3',
  };
  const matchDark = {
      img: generateImageUrl('images/Module15Images/practice/it is dark.png'),
      title: 'it is dark',
      audioPrompt: 'appfiles/active_listening/match_dark.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_nervous_dark.mp3',
  };
  const matchBaseball = {
      img: generateImageUrl('images/Module15Images/practice/you practiced baseball.png'),
      title: 'you practiced baseball',
      audioPrompt: 'appfiles/active_listening/match_played_baseball.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_confident_baseball.mp3',
  };
  const matchNewTeacher = {
      img: generateImageUrl('images/Module15Images/practice/you have a new teacher.png'),
      title: 'you have a new teacher',
      audioPrompt: 'appfiles/active_listening/match_new_teacher.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_nervous_teacher.mp3',
  };
  const matchMeet = {
      img: generateImageUrl('images/Module15Images/practice/you are meeting someone new.png'),
      title: 'you are meeting someone new',
      audioPrompt: 'appfiles/active_listening/match_meeting_someone_new.mp3',
      recordAudioPrompt: 'appfiles/active_listening/practice_record_prompt_nervous_someone_new.mp3',
  };
  // List possible questions with associated videos
  const madNoVideoGame = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_no_game.mp4',
    // video: "2af1f55cc459bf2e7db529f2eff0/480.m3u8",
    prompt: 'I am sorry you feel mad because',
    promptAudio: 'appfiles/active_listening/sorry_mad.mp3',
    correctSolutions: matchNoGame,
    incorrectSolutions: matchSwimming,
  };
  const calmReadBook = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_read_book.mp4',
    // video: "1ee16df484636411e145cf4e96ab/480.m3u8",
    prompt: 'I am glad you feel calm because',
    promptAudio: 'appfiles/active_listening/glad_calm.mp3',
    correctSolutions: matchReadBook,
    incorrectSolutions: matchLostToy,
  };
  const sadCannotPlayOutside = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_no_play_outside.mp4',
    // video: "59e1f3dd2b7f51b820f80e9bdda5/480.m3u8",
    prompt: 'I am sorry you feel sad because',
    promptAudio: 'appfiles/active_listening/sorry_sad.mp3',
    correctSolutions: matchNoPlayOutside,
    incorrectSolutions: matchReadBook,
  };
  const happySwimming = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_swim.mp4',
    // video: "3e6bfbcdb581793bfc5e0dc5c532/480.m3u8",
    prompt: 'I am glad you feel happy because',
    promptAudio: 'appfiles/active_listening/glad_happy.mp3',
    correctSolutions: matchSwimming,
    incorrectSolutions: matchNoGame,
  };
  const confidentWorkHard = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_work_hard.mp4',
    // video: "ca9d125830f5906ebe73f1aa4d53/480.m3u8",
    prompt: 'I am glad you feel confident because',
    promptAudio: 'appfiles/active_listening/glad_confident.mp3',
    correctSolutions: matchWorkedHard,
    incorrectSolutions: matchBrokePencil,
  };
  const nervousTest = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_test.mp4',
    // video: "11bd255831045049d24e72d3b455/480.m3u8",
    prompt: 'I am sorry you feel nervous because',
    promptAudio: 'appfiles/active_listening/sorry_nervous.mp3',
    correctSolutions: matchTest,
    incorrectSolutions: matchNewFriend,
  };
  const madBrokePencil = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_broke_pencil.mp4',
    // video: "8c36af545b6faf349129d4adc0cf/480.m3u8",
    prompt: 'I am sorry you feel mad because',
    promptAudio: 'appfiles/active_listening/sorry_mad.mp3',
    correctSolutions: matchBrokePencil,
    incorrectSolutions: matchAteLunch,
  };
  const sadLostToy = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_lost_toy.mp4',
    // video: "af1ef328834daaa88d2f799633e2/480.m3u8",
    prompt: 'I am sorry you feel sad because',
    promptAudio: 'appfiles/active_listening/sorry_sad.mp3',
    correctSolutions: matchLostToy,
    incorrectSolutions: matchWorkedHard,
  };
  const nervousMeetNew = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_meet_new.mp4',
    // video: "a15d323c2d14ce4175666f010b06/480.m3u8",
    prompt: 'I am sorry you feel nervous because',
    promptAudio: 'appfiles/active_listening/sorry_nervous.mp3',
    correctSolutions: matchMeet,
    incorrectSolutions: matchWonGame,
  };
  const madTired = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_tired.mp4',
    // video: "b8d05ea527f64d211737dc5229cd/480.m3u8",
    prompt: 'I am sorry you feel mad because',
    promptAudio: 'appfiles/active_listening/sorry_mad.mp3',
    correctSolutions: matchTired,
    incorrectSolutions: matchDidBest,
  };
  const madHungry = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_hungry.mp4',
    // video: "5b72a5767ae4ba85553b0c12fafd/480.m3u8",
    prompt: 'I am sorry you feel mad because',
    promptAudio: 'appfiles/active_listening/sorry_mad.mp3',
    correctSolutions: matchHungry,
    incorrectSolutions: matchNewFriend,
  };
  const sadSick = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_sick.mp4',
    // video: "8f912f9ebf4d3683faefee3156fa/480.m3u8",
    prompt: 'I am sorry you feel sad because',
    promptAudio: 'appfiles/active_listening/sorry_sad.mp3',
    correctSolutions: matchSick,
    incorrectSolutions: matchListenMusic,
  };
  const sadHurtKnee = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_hurt_knee.mp4',
    // video: "907d68667bc14fa8e29d044792e7/480.m3u8",
    prompt: 'I am sorry you feel sad because',
    promptAudio: 'appfiles/active_listening/sorry_sad.mp3',
    correctSolutions: matchHurtKnee,
    incorrectSolutions: matchBelieveInYou,
  };
  const nervousDark = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_dark.mp4',
    // video: "45a69535a1c7dcf22249c46f3a1f/480.m3u8",
    prompt: 'I am sorry you feel nervous because',
    promptAudio: 'appfiles/active_listening/sorry_nervous.mp3',
    correctSolutions: matchDark,
    incorrectSolutions: matchBaseball,
  };
  const nervousNewTeacher = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_new_teacher.mp4',
    // video: "3009ecec09406419e2ce8e477994/480.m3u8",
    prompt: 'I am sorry you feel nervous because',
    promptAudio: 'appfiles/active_listening/sorry_nervous.mp3',
    correctSolutions: matchNewTeacher,
    incorrectSolutions: matchNap,
  };
  const calmLunch = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_lunch.mp4',
    // video: "864795160c3c1e861ead4421c2dc/480.m3u8",
    prompt: 'I am glad you feel calm because',
    promptAudio: 'appfiles/active_listening/glad_calm.mp3',
    correctSolutions: matchAteLunch,
    incorrectSolutions: matchLostToy,
  };
  const happyNewFriend = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_new_friend.mp4',
    // video: "a9394c59db332d88aba6d438a846/480.m3u8",
    prompt: 'I am glad you feel happy because',
    promptAudio: 'appfiles/active_listening/glad_happy.mp3',
    correctSolutions: matchNewFriend,
    incorrectSolutions: matchBrokePencil,
  };
  const confidentBest = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_best.mp4',
    prompt: 'I am glad you feel confident because',
    promptAudio: 'appfiles/active_listening/glad_confident.mp3',
    correctSolutions: matchDidBest,
    incorrectSolutions: matchNoPlayOutside,
  };
  const calmMusic = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_music.mp4',
    // video: "a22a1d39eefd15ec1d3e6bf5746d/480.m3u8",
    prompt: 'I am glad you feel calm because',
    promptAudio: 'appfiles/active_listening/glad_calm.mp3',
    correctSolutions: matchListenMusic,
    incorrectSolutions: matchSick,
  };
  const calmNap = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_nap.mp4',
    // video: "d7f1a6acf4d4c27e018d29e47f01/480.m3u8",
    prompt: 'I am glad you feel calm because',
    promptAudio: 'appfiles/active_listening/glad_calm.mp3',
    correctSolutions: matchNap,
    incorrectSolutions: matchHungry,
  };
  const happyPlayOutside = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_play_outside.mp4',
    // video: "3f7cca9c7f44714036cf6a1ae1ed/480.m3u8",
    prompt: 'I am glad you feel happy because',
    promptAudio: 'appfiles/active_listening/glad_happy.mp3',
    correctSolutions: matchPlayOutside,
    incorrectSolutions: matchTest,
  };
  const happyWonGame = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_won_game.mp4',
    // video: "88695fbfec17cc7b8e7c6c014d81/480.m3u8",
    prompt: 'I am glad you feel happy because',
    promptAudio: 'appfiles/active_listening/glad_happy.mp3',
    correctSolutions: matchWonGame,
    incorrectSolutions: matchNoGame,
  };
  const confidentBelieve = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_believe.mp4',
    // video: "065337a9875b59f275680742c0a6/480.m3u8",
    prompt: 'I am glad you feel confident because',
    promptAudio: 'appfiles/active_listening/glad_confident.mp3',
    correctSolutions: matchBelieveInYou,
    incorrectSolutions: matchDark,
  };
  const confidentBaseball = {
    demoDay: true,
    video: 'appfiles/active_listening/practice_baseball.mp4',
    // video: "75026b97b769993e6806e35f1946/480.m3u8",
    prompt: 'I am glad you feel confident because ',
    promptAudio: 'appfiles/active_listening/glad_confident.mp3',
    correctSolutions: matchBaseball,
    incorrectSolutions: matchNewTeacher,
  };

  // Group possible answers into their respective feelings categories
  const madAnwsers = [madHungry, madBrokePencil, madNoVideoGame, madTired];
  const nervousAnwsers = [
    nervousDark,
    nervousNewTeacher,
    nervousMeetNew,
    nervousTest,
  ];
  const sadAnwsers = [sadSick, sadHurtKnee, sadLostToy, sadCannotPlayOutside];
  const confidentAnwsers = [
    confidentBaseball,
    confidentBelieve,
    confidentBest,
    confidentWorkHard,
  ];
  const happyAnwsers = [
    happyWonGame,
    happyPlayOutside,
    happyNewFriend,
    happySwimming,
  ];
  const calmAnwsers = [calmNap, calmMusic, calmLunch, calmReadBook];

  // Get the gifs to allow the bird to talk
  useEffect(() => {
    setIntroSound(getVideo('appfiles/understand_feelings/choose_feelings.mp3', login));
  }, []);

  // If we are past the third day, update the database on the user&apos;s practice progress.
  useEffect(() => {
    if (practiceCount >= 3) {
    }
  }, [practiceCount]);

  // Based on the day, choose the video to play
  useEffect(() => {
    if (props.unit4) {
      setDisplayPracticeVideo(props.reviewVideo);
      setPracticeVideo(true);
    }
    else{
      switch (props.module.currentday) {
        case 1:
          setDisplayPracticeVideo(getVideo('appfiles/active_listening/practice_day_1.mp4', login));
          setPracticeVideo(true);
          break;
        case 2:
          setDisplayPracticeVideo(getVideo('appfiles/active_listening/practice_day_2.mp4', login));
          setPracticeVideo(true);
          break;
        case 3:
          setDisplayPracticeVideo(getVideo('appfiles/active_listening/practice_day_3.mp4', login));
          setPracticeVideo(true);
          break;
        default:
          setPractice(true);
          setQuestion(true);
          break;
      }
    }

  }, []);

  // Set a timer for ms milliseconds
  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Based on the chosen feeling, pick a question, and two possible answers. Then set them up so the user can select one.
  async function setupGame(feeling) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    setKeyword(feeling);
    setQuestion(false);
    setIntroSound('');
    setAnswerkey(null);
    setPractice(false);
    let number = 0;
    let numArray = [];
    switch (feeling) {
      case 'nervous':
        number = getRandomInt(nervousAnwsers.length);
        setChangeAnswer(nervousAnwsers[number].prompt);
        setAnimalVoice(await getVideo(nervousAnwsers[number].promptAudio, login));
        setDisplayPracticeVideo1(await getVideo(nervousAnwsers[number].video, login));
        nervousAnwsers[number].correctSolutions.correct = true;
        nervousAnwsers[number].incorrectSolutions.correct = false;
        numArray = [
          nervousAnwsers[number].correctSolutions,
          nervousAnwsers[number].incorrectSolutions,
        ];
        break;
      case 'sad':
        number = getRandomInt(sadAnwsers.length);
        setChangeAnswer(sadAnwsers[number].prompt);
        setAnimalVoice(await getVideo(sadAnwsers[number].promptAudio, login));
        setDisplayPracticeVideo1(await getVideo(sadAnwsers[number].video, login));
        sadAnwsers[number].correctSolutions.correct = true;
        sadAnwsers[number].incorrectSolutions.correct = false;
        numArray = [
          sadAnwsers[number].correctSolutions,
          sadAnwsers[number].incorrectSolutions,
        ];
        break;
      case 'mad':
        number = getRandomInt(madAnwsers.length);
        setChangeAnswer(madAnwsers[number].prompt);
        setAnimalVoice(await getVideo(madAnwsers[number].promptAudio, login));
        setDisplayPracticeVideo1(await getVideo(madAnwsers[number].video, login));
        madAnwsers[number].correctSolutions.correct = true;
        madAnwsers[number].incorrectSolutions.correct = false;
        numArray = [
          madAnwsers[number].correctSolutions,
          madAnwsers[number].incorrectSolutions,
        ];
        break;
      case 'confident':
        number = getRandomInt(confidentAnwsers.length);
        setChangeAnswer(confidentAnwsers[number].prompt);
        setAnimalVoice(await getVideo(confidentAnwsers[number].promptAudio, login));
        setDisplayPracticeVideo1(await getVideo(confidentAnwsers[number].video, login));
        confidentAnwsers[number].correctSolutions.correct = true;
        confidentAnwsers[number].incorrectSolutions.correct = false;
        numArray = [
          confidentAnwsers[number].correctSolutions,
          confidentAnwsers[number].incorrectSolutions,
        ];
        break;
      case 'happy':
        number = getRandomInt(happyAnwsers.length);
        setChangeAnswer(happyAnwsers[number].prompt);
        setAnimalVoice(await getVideo(happyAnwsers[number].promptAudio, login));
        setDisplayPracticeVideo1(await getVideo(happyAnwsers[number].video, login));
        happyAnwsers[number].correctSolutions.correct = true;
        happyAnwsers[number].incorrectSolutions.correct = false;
        numArray = [
          happyAnwsers[number].correctSolutions,
          happyAnwsers[number].incorrectSolutions,
        ];
        break;
      case 'calm':
        number = getRandomInt(calmAnwsers.length);
        setChangeAnswer(calmAnwsers[number].prompt);
        setAnimalVoice(await getVideo(calmAnwsers[number].promptAudio, login));
        setDisplayPracticeVideo1(await getVideo(calmAnwsers[number].video, login));
        calmAnwsers[number].correctSolutions.correct = true;
        calmAnwsers[number].incorrectSolutions.correct = false;
        numArray = [
          calmAnwsers[number].correctSolutions,
          calmAnwsers[number].incorrectSolutions,
        ];
        break;
      default:
        break;
    }
    numArray = numArray
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
    setOption1(numArray[0]);
    setOption2(numArray[1]);
    setPracticeCount(++practiceCount);
    setPracticeVideo1(true);
  }

  // Determine what the user picked as an answer and play the associated audio/video
  async function setAnswer(feeling, index) {
    for (let x = 0; x < document.getElementsByClassName("optionImage16").length; x++){
      document.getElementsByClassName("optionImage16")[x].style.borderColor  = 'black'
    }
    document.getElementsByClassName("optionImage16")[index].style.borderColor  = 'yellow'
    setAnswerkey(feeling);
    setAnimalVoice('');
    setAnimaTalk(false);
    setIntroSound('');
    setQuestion(false);
    setAnimalVoice(await getVideo(feeling.audioPrompt, login));
    setAnimaTalk(true);
  }
  const updateScore = async () => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: "practice_active_listening",
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score, target: 2 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const recordingStart = async () => {
    updateScore();
    props.module.sectionCompleted = props.module.sectionCompleted + 1
    if (props.module.currentday <= 3 && !props.unit4) {
      const text = [
        'Press record and say, "Goodbye!"',
        'Press record and say, "See you later!"',
        'Press record and say, "Bye!"',
      ];
      const introVideo = [
        'appfiles/active_listening/practice_day_1_review.mp4',
        'appfiles/active_listening/practice_day_2_review.mp4',
        'appfiles/active_listening/practice_day_3_review.mp4',
      ];
      const influencers = [
        login.influencerid,
        login.influencerid1,
        login.influencerid2,
      ];
      let voice1 = await getVideo(`appfiles/close/close_practice_record_${props.module.currentday + 4}.mp3`, login);
      let voice2 = await getVideo('appfiles/close/close_practice_special_message.mp3', login);
      let voice3 = await getVideo('appfiles/close/close_practice_watch_conversation.mp3', login);
      let voice4 = await getVideo('appfiles/close/close_awesome_job.mp3', login);
      let response = await getVideo(`appfiles/close/close_response_${props.module.currentday + 4}.mp4`, login);
      let greeting = await getVideo(`appfiles/close/close_greeting_${props.module.currentday + 4}.mp4`, login);
      let question7 = await getVideo(`appfiles/close/close_question_${props.module.currentday + 4}.mp4`, login);
      let acknowledge7 = await getVideo(`appfiles/close/close_acknowledge_${props.module.currentday + 4}.mp4`, login);
      let close = await getVideo(`appfiles/close/close_close_${props.module.currentday + 4}.mp4`, login);
      let influencerVideo = await GetUserVideo(`influencers/${influencers[props.module.currentday - 1]}/close_video_message.mp4`, login);
      let greetingResponse = await GetUserVideo(`userfiles/${props.module.StudentID}/feelings_practice_video_${props.module.currentday}.mp4`, login);
      let response7 = await GetUserVideo(`userfiles/${props.module.StudentID}/understand_feelings_practice_video_${props.module.currentday}.mp4`, login);
      let ask = await GetUserVideo(`userfiles/${props.module.StudentID}/change_feelings_practice_video_${props.module.currentday}.mp4`, login);
      let acknowledge = await GetUserVideo(`userfiles/${props.module.StudentID}/solutions_practice_video_${props.module.currentday}.mp4`, login);
      setPracticeRrcording(
        <Day4Practice
          bigAnimal={true}
          module={props.module}
          celebrateVideo={
            introVideo[
              props.module.currentday - 1
            ]
          }
          response7={response7}
          acknowledge={acknowledge}
          greetingResponse={greetingResponse}
          acknowledge7={acknowledge7}
          question7={question7}
          ask={ask}
          response={response}
          background={props.background}
          influencerVideo={influencerVideo}
          question={close}
          close={close}
          text={
            text[props.module.currentday - 1]
          }
          voice1={voice1}
          voice2={voice2}
          voice3={voice3}
          voice4={voice4}
          animate2={props.specialMessage}
          animate3={props.conversationGIF}
          animate4={props.endGIF}
          name={`active_listening_practice_video_${props.module.currentday}.mp4`}
          greeting={greeting}
          closeVoice={voice4}
          animal={props.animal}
          setDisplayDay4Practice={
            props.setDisplayPractice
          }
          moduleNum={'MODULE15'}
        />
      );
      setMatchGame(false);
      setPracticeReview(true);
                                     
    } else {
      if (props.module.reviewIcon === false) {
        dispatch({ type: props.stepComplete, payload: 'practice' });
      }
      props.setDisplayPractice(false);
    }
  };
  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  useEffect(() => {
    let timer;
    if(animalTalk && isIOS()) {
      timer = setTimeout(() => {
        setAnimaTalk(false);
        if (conversation) {
          setConversation(false);
          setConversation1(true);
        } else if (conversationEnd) {
          setConversationEnd(false);
          if (practiceCount <= 1) {
            if (keyword === 'nervous') {
              setupGame('confident');
            } else if (keyword === 'sad') {
              setupGame('happy');
            } else if (keyword === 'mad') {
              setupGame('calm');
            }
          } else {
            recordingStart();
          }
        }
      }, 5000);
    }
    return () => {
      if(timer) clearTimeout(timer);
    }
  }, [animalTalk]);

  // The HTML code for the practice module
  return (
    <>
      {practiceVideo && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo}
          back='/activelistening'
          background={props.background}
          close={props.setDisplayPractice}
          ended={() => {
            setPracticeVideo(false);
            switch (props.module.currentday) {
              case 1:
                setupGame('nervous')
                break;
              case 2:
                setupGame('sad')
                break;
              case 3:
                setupGame('mad')
                break;
              default:
                setParcticeIntro(true);
                break;
            }
          }}
        />
      )}
      {parcticeIntro && (
        <CloudfrontVideoFormat
          source={getVideo('appfiles/answer/practice_instructions.mp4', login)}
          back='/activelistening'
          background={props.background}
          close={props.setDisplayPractice}
          ended={() => {
            setParcticeIntro(false);
            setPractice(true);
            setQuestion(true);
          }}
        />
      )}
      {practice && (
        <div
          className='Module15Practice'
          style={{ backgroundImage: `url(${background})` }}
        >
          <img
            className='back-btn-ftb'
            alt=''
            src={Exit}
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>
            Which feelings do you want to practice?
          </h2>

          <div className='grid15'>
            <div className='grid-item' onClick={() => setupGame('nervous')}>
              <img
                alt=''
                className='crabExpression15'
                src={Nervous_Confident}
              />
              <h3 className='practiceText12'>Nervous & Confident</h3>
            </div>
            <div className='grid-item' onClick={() => setupGame('sad')}>
              <img alt='' className='crabExpression15' src={Sad_happy} />
              <h3 className='practiceText12'>Sad & Happy</h3>
            </div>
            <div className='grid-item' onClick={() => setupGame('mad')}>
              <img alt='' className='crabExpression15' src={Mad_Calm} />
              <h3 className='practiceText12'>Mad & Calm</h3>
            </div>
          </div>
        </div>
      )}
      {practiceVideo1 && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo1}
          back='/activelistening'
          background={background}
          close={props.setDisplayPractice}
          ended={() => {
            setPracticeVideo1(false);
            setIntroSound(getVideo('appfiles/active_listening/scenario_prompt.mp3', login));
            setMatchGame(true);
            setQuestion(true);
          }}
        />
      )}

      {matchGame && (
        <div
          className='Module15MatchGame'
          style={{ backgroundImage: `url(${background})` }}
        >
          <img
            className='back-btn-ftb'
            src={Exit}
            alt=''
            onClick={() => {
              props.setDisplayPractice(false);
            }}
          ></img>
          <br />
          <h2 className='practiceHeader12'>
            What can you say to show you are listening?
          </h2>
          <h3 className='practiceQuestion12'>{changeAnswer}</h3>
          {(
            <img
              className='greenCheckPractice12'
              style={{opacity : answerkey ? 1 : 0, pointerEvents : answerkey ? "auto" : "none"}}
              src={greenCheck}
              alt=''
              onClick={() => {
                setAnimalVoice('');
                setAnimaTalk(false);
                if (answerkey.correct) {
                  setAnimalVoice(getVideo(answerkey.recordAudioPrompt, login));
                  setMatchGame(false);
                  setRecording(true);
                  if(firstTime) setScore(score+1);
                  const audio = new Audio(
                    generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  audio.play();
                  setFirstTime(true);
                } else {
                  setFirstTime(false);
                  let sound = new Audio(getVideo('appfiles/eye_contact/andrea_try_again.mp3', login));
                  sound.play();
                  setAnswerkey(null);
                }
              }}
            />
          )}
          <br />
          <br />
          {answerkey ? (
            <div className='optionImage14'>
              <img alt='Answer Key' src={answerkey.img} />
              {/* <h4 className='practiceText12'>{answerkey.title}</h4> */}
            </div>
          ) : (
            <img alt='' id='selectCrab14' src={selectImage} />
          )}
          <div className='gameGrid14'>
            <div className='optionImage16' onClick={() => setAnswer(option1 ,0)}>
              <img alt='Option 1' src={option1.img} />
              {/* <h4 className='practiceText12'>{option1.title}</h4> */}
            </div>
            <div className='optionImage16' onClick={() => setAnswer(option2, 1)}>
              <img alt='Option 2' src={option2.img} />
              {/* <h4 className='practiceText12'>{option2.title}</h4> */}
            </div>
          </div>
        </div>
      )}
      {recording && (
        <VideoWebcamRecorder
          background={background}
          outputText={`"${changeAnswer} ${answerkey.title}."`}
          name={`${practiceCount}_${props.name}`}
          setConversation={setConversation}
          setRecording={setRecording}
          animal={props.animal}
          voice1={animalVoice}
          close={props.setDisplayPractice}
          setDisplayPracticeVideo2={setDisplayPracticeVideo2}
        />
      )}
      {conversation && (
        <div
          className='Module15Conversation'
          style={{ backgroundImage: `url(${background})` }}
        >
          {audioReady && <img
            alt=''
            className='bird20'
            src={props.conversationGIF}
            onLoad={() => (
              setAnimalVoice(props.conversationAudio), setAnimaTalk(true)
            )}
          />}
        </div>
      )}
      {conversation1 && (
        <CloudfrontVideoFormat
          source={displayPracticeVideo1}
          back='/activelistening'
          background={background}
          close={props.setDisplayPractice}
          ended={() => {
            setConversation1(false);
            setConversation2(true);
          }}
        />
      )}
      {conversation2 && (
        <div
          id='recordpage'
          style={{ backgroundImage: `url(${props.background})` }}
        >
        <div id='border'>
          <video
            style={{ width: '391px', height: '580px', left: '50%' }}
            autoPlay
            controls={isIOS() ? showStart : false}
            onPlaying={() => {
              setShowStart(false);
            }}
            onEnded={() => (setConversation2(false), setConversationEnd(true))}
            onError={() => (setConversation2(false), setConversationEnd(true))}
            playsInline
          >
            <source src={displayPracticeVideo2} type='video/mp4'></source>
          </video>
        </div>
        </div>
      )}

      {conversationEnd && (
        <div
          className='Module15Conversation'
          style={{ backgroundImage: `url(${background})` }}
        >
          {audioReady && <img
            alt=''
            className='bird20'
            src={props.endGIF}
            onLoad={() => (setAnimalVoice(props.endAudio), setAnimaTalk(true))}
          />}
        </div>
      )}

      {practiceReview && practiceRrcording}

      {!animalTalk && question && (
        <audio
          autoPlay
          onEnded={() => {
            setQuestion(false);
            if (matchGame) {
              setAnimaTalk(true);
            }
          }}
        >
          <source src={introSound}></source>
        </audio>
      )}
      {animalTalk && (
        <audio
          autoPlay
          onPlay={() => {
            setAudioReady(true);
          }}
          onEnded={() => {
            setAnimaTalk(false);
            if (conversation) {
              setConversation(false);
              setConversation1(true);
            } else if (conversationEnd) {
              setConversationEnd(false);
              if (practiceCount <= 1) {
                if (keyword === 'nervous') {
                  setupGame('confident');
                } else if (keyword === 'sad') {
                  setupGame('happy');
                } else if (keyword === 'mad') {
                  setupGame('calm');
                }
              } else {
                recordingStart();
              }
            }
          }}
        >
          <source src={animalVoice}></source>
        </audio>
      )}
    </>
  );
};
export default ActivelisteningPractice;
